/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { DataProvider } from '../model/dataProvider';
import { DataProviderCreateRequest } from '../model/dataProviderCreateRequest';
import { DataProviderKeys } from '../model/dataProviderKeys';
import { ErrorInformation } from '../model/errorInformation';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable({
  providedIn: 'root'
})
export class DataProviderService {

    protected basePath = 'http://localhost/herd-app/rest';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {

        if (configuration) {
            this.configuration = configuration;
            this.configuration.basePath = configuration.basePath || basePath || this.basePath;

        } else {
            this.configuration.basePath = basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * createDataProvider
     * Creates a new data provider.
     * @param dataProviderCreateRequest the information needed to create the data provider
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public dataProviderCreateDataProvider(dataProviderCreateRequest: DataProviderCreateRequest, observe?: 'body', reportProgress?: boolean): Observable<DataProvider>;
    public dataProviderCreateDataProvider(dataProviderCreateRequest: DataProviderCreateRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DataProvider>>;
    public dataProviderCreateDataProvider(dataProviderCreateRequest: DataProviderCreateRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DataProvider>>;
    public dataProviderCreateDataProvider(dataProviderCreateRequest: DataProviderCreateRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (dataProviderCreateRequest === null || dataProviderCreateRequest === undefined) {
            throw new Error('Required parameter dataProviderCreateRequest was null or undefined when calling dataProviderCreateDataProvider.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<DataProvider>(`${this.configuration.basePath}/dataProviders`,
            dataProviderCreateRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * deleteDataProvider
     * Deletes an existing data provider by data provider name.
     * @param dataProviderName the data provider name
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public dataProviderDeleteDataProvider(dataProviderName: string, observe?: 'body', reportProgress?: boolean): Observable<DataProvider>;
    public dataProviderDeleteDataProvider(dataProviderName: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DataProvider>>;
    public dataProviderDeleteDataProvider(dataProviderName: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DataProvider>>;
    public dataProviderDeleteDataProvider(dataProviderName: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (dataProviderName === null || dataProviderName === undefined) {
            throw new Error('Required parameter dataProviderName was null or undefined when calling dataProviderDeleteDataProvider.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<DataProvider>(`${this.configuration.basePath}/dataProviders/${encodeURIComponent(String(dataProviderName))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getDataProvider
     * Gets an existing data provider by data provider name.
     * @param dataProviderName the data provider name
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public dataProviderGetDataProvider(dataProviderName: string, observe?: 'body', reportProgress?: boolean): Observable<DataProvider>;
    public dataProviderGetDataProvider(dataProviderName: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DataProvider>>;
    public dataProviderGetDataProvider(dataProviderName: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DataProvider>>;
    public dataProviderGetDataProvider(dataProviderName: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (dataProviderName === null || dataProviderName === undefined) {
            throw new Error('Required parameter dataProviderName was null or undefined when calling dataProviderGetDataProvider.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<DataProvider>(`${this.configuration.basePath}/dataProviders/${encodeURIComponent(String(dataProviderName))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getDataProviders
     * Gets a list of data provider keys for all data providers defined in the system.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public dataProviderGetDataProviders(observe?: 'body', reportProgress?: boolean): Observable<DataProviderKeys>;
    public dataProviderGetDataProviders(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DataProviderKeys>>;
    public dataProviderGetDataProviders(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DataProviderKeys>>;
    public dataProviderGetDataProviders(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<DataProviderKeys>(`${this.configuration.basePath}/dataProviders`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
